import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface IAccountUser {
    id: string;
    email: string;
    displayName: string | null;
    inGroup: boolean;
    isAdmin: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    constructor(private http: HttpClient) {
    }

    public getCurrentUser() {
        return this.http.get<IAccountUser | null>('/api/account/me');
    }

    public loadCurrentUser(): Promise<IAccountUser | null> {
        return firstValueFrom(this.getCurrentUser())
            .catch(error => {
                console.error('account/me failed', error);
                return null;
            });
    }
}
